import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Initials for an avatar fallback — up to two letters taken from a display
 * name ("Aarav Sharma" -> "AS", "Admin" -> "A").
 *
 * Issue #294: the topbar and the profile page used to paint a hardcoded
 * stock photograph of a stranger over every account, so the initials branch
 * they already had (`display_name?.[0]`) never rendered for anyone. This is
 * that branch, widened from one letter to first+last so two people whose
 * names share an initial are still distinguishable, and centralised so the
 * two call sites cannot drift.
 *
 * Returns "" for anything unusable, so callers keep ownership of their own
 * last-resort glyph rather than inheriting one from here.
 */
export function initialsFrom(name) {
  if (typeof name !== "string") return "";
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "";
  // Array.from, not [0]: a name can begin with an astral character (an
  // emoji, or a script outside the BMP), and indexing a string would slice
  // a surrogate pair in half and render a replacement box.
  const firstOf = (word) => Array.from(word)[0] || "";
  const initials =
    words.length > 1 ? firstOf(words[0]) + firstOf(words[words.length - 1]) : firstOf(words[0]);
  return initials.toUpperCase();
}
